import { createContext } from 'react'

const contextPayload = {
  isValid: undefined
}

const AuthorizationContext = createContext(contextPayload)
AuthorizationContext.displayName = 'authorization-context'

export default AuthorizationContext
